<template>
  <div style="width: 100%; background: #f8f8f8">
    <div class="topCommon">
      <div class="logo">
        <img src="../../assets/images/logo.png" alt="" />
      </div>
    </div>
    <div v-if="nav">
      <div class="topBox">
        <div class="typeBox">
          <img
            src="@/assets/images/zsy_icon_01.png"
            alt=""
            style="transform: none; cursor: auto"
          />
          <img
            src="../../assets/images/0445_03.jpg"
            alt=""
            @click="jump('index')"
          />
          <img
            src="../../assets/images/0445_05.jpg"
            alt=""
            @click="jump('szyw')"
          />
          <img
            src="../../assets/images/0445_09.jpg"
            alt=""
            @click="jump('gfjj')"
          />
          <img
            src="../../assets/images/0445_11.jpg"
            alt=""
            @click="jump('hyss')"
          />
          <img
            src="../../assets/images/0445_13.jpg"
            alt=""
            @click="jump('qyqcss')"
          />
          <img
            src="../../assets/images/0445_15.jpg"
            alt=""
            @click="jump('sgcy')"
          />
          <img
            src="../../assets/images/0445_17.jpg"
            alt=""
            @click="jump('kjcy')"
          />
          <img
            src="../../assets/images/0445_19.jpg"
            alt=""
            @click="jump('ssyh')"
          />
          <img
            src="@/assets/images/0445_07.jpg"
            alt=""
            @click="jump('jckss')"
          />
        </div>
        <div class="search">
            <!--搜索联想-->
            <div class="searchLenovo" v-if="searchText!==''">
                <div class="sLevovoTitle">搜索联想</div>
                <div class="sLevovoKey">{{ searchText }}:</div>
                <div class="sLevovoRight">
                    <div class="sLenovoScroll" v-if="lenovoList.length!=0">
                        <template v-for="(item,index) in lenovoList" >
                            <span @click="lenovoCheck(item)" class="textList" v-html="item.highlight" :key="index"></span>
                        </template>
                    </div>
                    <div class="sLenovoScroll" v-if="lenovoList.length==0">
                        未获取检索联想词
                    </div>
                </div>
            </div>
            <!--搜索历史-->
            <div class="searchHistory" v-if="searchText===''">
                <div class="sHistoryTitle">最近搜索:</div>
                <div class="sHistoryRight">
                    <div class="sHistoryScroll" v-if="historyList.length!=0">
                        <template v-for="(item,index) in historyList" >
                            <span @click="historyClick(item)" class="textListHistory" v-html="item" :key="index"></span>
                        </template>
                    </div>
                    <div class="sHistoryScroll" v-if="historyList.length==0">
                        暂无最近搜索记录
                    </div>
                </div>
            </div> 
          <div>
            <el-input
              v-model="input"
              @input="fillHotWords()"
              placeholder="请输入要搜索的关键词，两个以上关键词用空格分开"
              class="searchInput"
            ></el-input>
            <el-button type="primary" class="searchType" @click="sousuo(1)"
              >按正文<span style="color: #ffe200; padding-left: 5px"
                >全面搜索</span
              ></el-button
            >
            <el-button type="primary" class="searchType" @click="sousuo(2)"
              >按标题<span style="color: #ffe200; padding-left: 5px"
                >极速搜索</span
              ></el-button
            >
            <el-button type="primary" class="searchType" @click="sousuo(3)"
              >按文号<span style="color: #ffe200; padding-left: 5px"
                >特定搜索</span
              ></el-button
            >
          </div>
        </div>
      </div>
      <!-- <div style="width: 100%; background: #f5f5f5; padding: 20px 0 0 0">
        <div class="banner">
          <img src="@/assets/images/00_banner_1200px_120px.png" alt="" />
          <img src="@/assets/images/btn.png" alt="" @click="drawer = true" style="cursor: pointer;">
        </div>
      </div> -->
    </div>
    <el-drawer title="我的咨询记录" :visible.sync="drawer" size="600px">
      <el-table :data="consultList" style="width: 100%">
        <el-table-column prop="name" label="咨询标题"> </el-table-column>
        <el-table-column prop="time" label="咨询时间" width="150">
        </el-table-column>
        <el-table-column label="操作" width="120px">
          <template slot-scope="scope">
            <div
              @click="navJump(scope.row.id)"
              style="
                width: 40px;
                height: 20px;
                line-height: 20px;
                border: 1px solid #003fa8;
                text-align: center;
                font-size: 14px;
                color: #003fa8;
                cursor: pointer;
              "
            >
              查看
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>
    <div class="midCommon">
      <router-view :key="$route.fullPath" />
    </div>

    <div class="hea" v-if="fpList.length==0">
      <div style="display: flex; align-items: center">
        <p class="heaone">检索条件</p>
        <div v-if="keyword != ''" style="display:flex;align-items:center" class="fenone">
           <div class="heatwo" v-for="(item,index) in fen" :key="index">
          <p class="heachang" style="padding-left: 10px" >
            <span style="margin-right: 10px">{{inputId==1?'正文'+(index+1)+':' + item:(inputId==2?'标题'+(index+1)+':' + item:'文号'+(index+1)+':' +item)}}</span>
          </p>
          <img
            src="../../assets/dtcdd21.png"
            alt=""
            style="padding-right: 10px; margin-left: 10px"
            @click="getdel(item,1)"
          />
        </div>
        </div>
       
        <div class="heatwo" v-if="name != ''">
          <p class="heachang" style="padding-left: 10px">
            <span style="margin-right: 10px">分类 : {{ name }}</span>
          </p>
          <img
            src="../../assets/dtcdd21.png"
            alt=""
            style="padding-right: 10px; margin-left: 10px"
            @click="getdel(2,2)"
          />
        </div>
      </div>
      <div style="display: flex; align-items: center">
         <p style="margin-right: 40px; font-size: 16px">
          共<span style="color: #f65428">{{ total }}条</span
          >数据
        </p>
        <div style="display: flex; align-items: center; cursor: pointer;margin-right: 20px;" @click="getji">
        <img src="../../assets/jilu.png" alt=""  style="width:18px;height:18px">
        <p style="color:#124baa;margin-left: 8px;">记录</p>
        </div>
        <div style="display: flex; align-items: center; cursor: pointer;;margin-right: 20px;" @click="getbao">
          <img src="../../assets/baocun.png" alt="" style="width:18px;height:18px">
          <p style="color:#124baa;margin-left: 8px;">保存</p>
        </div>
        <div class="headel" @click="getdel(3,3)">
          <img
            src="../../assets/del.png"
            alt=""
            style="margin-right: 8px;width:20px;height:20px"
          />
          <p style="color:red" class="heaqingkong">清空</p>
        </div>
      </div>
    </div>
    <div class="con" v-if="fpList.length==0">
      <div class="left">
        <div class="leftone"></div>
        <div class="lefttwo">
          <p class="lefttwowenzi">法规</p>
        </div>
        <div class="tree">
          <div style="height: 30px; width: 300px"></div>
          <div class="treeone" v-for="(item, index) in tr" :key="index">
            <div class="treeoneone" @click.stop="getzhan(item)" :class="{actyifenlei:item.if==true}">
              <p
                style="
                  margin-left: 20px;
                  display: flex;
                  align-items: center;
                  flex-wrap: wrap;
                  /* padding: 5px 0; */
                "
                :class="{actyifenleiwenzi:item.if==true}"
              >
                {{ item.name }} &nbsp;<span
                  style="font-size: 14px; color: #c22424"
                  >({{ item.count }})</span
                >
              </p>
              <div class="zhan">
                {{ item.if == false ? "展开" : "收起" }}
              </div>
            </div>

            <div class="treetwo" v-if="item.if">
              <div
                @click.stop="geterzhan(it, item)"
                class="treethree"
                v-for="(it, index) in item.tags"
                :key="index"
              >
                <div style="display: flex; align-items: center; padding: 5px 0">
                  <p class="treethreexian"></p>
                  <p class="erjia" v-if="it.children != null">
                    {{ it.erif == false ? "+" : "-" }}
                  </p>
                  <p
                    style="
                      margin-left: 5px;
                      display: flex;
                      align-items: center;
                      flex-wrap: wrap;
                      padding: 5px 0;
                    "
                    :class="{ actcheck: checkId == it.id }"
                  >
                    {{ it.name }} &nbsp;<span
                      style="font-size: 14px; color: #c22424"
                      >({{ it.count }})</span
                    >
                  </p>
                </div>

                <div class="sanji" v-if="it.children != null">
                  <div class="sanjione" v-if="it.erif">
                    <div
                      class="sanjihang"
                      v-for="(ii, index) in it.children"
                      :key="index"
                      @click.stop="getsanji(ii, it, item)"
                    >
                      <p class="treethreexian"></p>
                      <p
                        style="
                          margin-left: 5px;
                          display: flex;
                          align-items: center;
                          flex-wrap: wrap;
                          padding: 5px 0;
                        "
                        :class="{ actcheck: checkIdsan == ii.id }"
                      >
                        <span>{{ ii.name }} </span>&nbsp;<span
                          style="font-size: 14px; color: #c22424"
                          >({{ ii.count }})</span
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="rightone">
          <p style="font-size: 18px; color: #124baa; margin-left: 30px">
            现行有效法规:
          </p>
          <div
            :class="{ actrione: xlIdone == it.id }"
            class="rione"
            v-for="(it, index) in xl"
            :key="index"
            @click="getfg(it)"
          >
            {{ it.name }}
          </div>
        </div>
        <div class="rightone">
          <p style="font-size: 18px; color: #124baa; margin-left: 30px">
            明确失效法规:
          </p>
          <div
            :class="{ actrione: xlIdone == it.id }"
            class="rione"
            v-for="(it, index) in xlone"
            :key="index"
            @click="getfg(it)"
          >
            {{ it.name }}
          </div>
        </div>
        <div class="rightone riri">
          <p style="font-size: 18px; color: #124baa; margin-left: 30px">
            尚未生效法规:
          </p>
          <div
            :class="{ actrione: xlIdone == it.id }"
            class="rione"
            v-for="(it, index) in xltwo"
            :key="index"
            @click="getfg(it)"
          >
            {{ it.name }}
          </div>
        </div>
        <div class="rightone riri" v-if="ids == 1">
          <div
            :class="{ actrionetwo: hangId == it.id }"
            class="rionetwo"
            v-for="(it, index) in hang"
            :key="index"
            @click="gethang(it)"
          >
            {{ it.name }}
          </div>
        </div>
        <div class="ritwo" v-if="totaltol != 0">
          <div
            class="rithree"
            v-for="(it, index) in list"
            :key="index"
            @click="getDetail(it)"
          >
            <div style="display: flex; align-items: center; margin-top: 15px">
              <img
                src="../../assets/dian.png"
                alt=""
                style="width: 8px; height: 8px; margin-right: 6px"
              />
              <p class="tifour" v-html="it.title"></p>
            </div>
            <p class="riwu">
              <span v-if="it.editor != null">{{ it.editor }} / </span>
              <span v-if="it.publishDate != null"> {{ it.publishDate }} / </span>
              <span v-if="it.modelId == 'fagui' && it.xlfw !=null">{{it.xlfw=='全文失效'?'全文废止':it.xlfw }}</span>
            </p>
          </div>
        </div>
        <div
          v-if="totaltol != 0"
          style="
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding-bottom: 30px;
          "
        >
          <div class="fenye">
            <div
              @click="getpage(1)"
              :class="{ actfenye: pageIndex == 1 }"
              class="fenoneone"
            >
              首页
            </div>
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="pageSize"
              :total="totaltol"
              next-text="下一页"
              prev-text="上一页"
              @current-change="handleCurrentChange"
              :current-page="pageIndex"
            >
            </el-pagination>
            <div
              @click="getpage(4)"
              :class="{ actfenye: pageIndex == Math.ceil(this.totaltol / 10) }"
              class="fenoneone"
            >
              尾页
            </div>
          </div>
        </div>
        <img
          v-if="totaltol == 0"
          src="../../assets/wu.png"
          alt=""
          style="width: 500px; height: 300px"
        />
      </div>
    </div>
    <!--分屏的样式-->
    <div class="fp" v-if="fpList.length!=0">
        <div class="fpLeft" :class="leftClass">
            <div class="fpLeftTop">
                <div class="hea" v-if="(fenbianlvType==true)||(fpList.length<2)">
                    <div style="display: flex; align-items: center">
                        <p class="heaone">检索条件</p>
                        <div v-if="keyword != ''" style="display:flex;align-items:center" class="fenone">
                        <div class="heatwo" v-for="(item,index) in fen" :key="index">
                        <p class="heachang" style="padding-left: 10px" >
                        <span style="margin-right: 10px">{{inputId==1?'正文'+(index+1)+':' + item:(inputId==2?'标题'+(index+1)+':' + item:'文号'+(index+1)+':' +item)}}</span>
                        </p>
                        <img
                          src="../../assets/dtcdd21.png"
                          alt=""
                          style="padding-right: 10px; margin-left: 10px"
                          @click="getdel(item,1)"
                        />
                      </div>
                      </div>
                        <div class="heatwo" v-if="name != ''">
                        <p class="heachang" style="padding-left: 10px">
                            <span style="margin-right: 10px">{{ name }}</span>
                        </p>
                        <img
                            src="../../assets/dtcdd21.png"
                            alt=""
                            style="padding-right: 10px; margin-left: 10px"
                            @click="getdel(2,2)"
                        />
                        </div>
                    </div>
                    <div style="display: flex; align-items: center">
                      <p style="margin-right: 40px; font-size: 16px">
                        共<span style="color: #f65428">{{ total }}条</span
                        >数据
                        </p>
                       <div style="display: flex; align-items: center; cursor: pointer;margin-right: 20px;" @click="getji">
                      <img src="../../assets/jilu.png" alt=""  style="width:18px;height:18px">
                      <p style="color:#124baa;margin-left: 8px;">记录</p>
                      </div>
                      <div style="display: flex; align-items: center; cursor: pointer;;margin-right: 20px;" @click="getbao">
                        <img src="../../assets/baocun.png" alt="" style="width:18px;height:18px">
                        <p style="color:#124baa;margin-left: 8px;">保存</p>
                      </div>
                        <div class="headel" @click="getdel(3,3)">
                        <img
                            src="../../assets/dtcdd22.png"
                            alt=""
                            style="margin-right: 8px"
                        />
                        <p class="heaqingkong">清空</p>
                        </div>
                    </div>
                    </div>
            </div>
            <div class="fpLeftBottom">
                <div class="fpLeftBottomLeft">
                    <div class="left">
                        <div class="leftone"></div>
                        <div class="lefttwo">
                        <p class="lefttwowenzi">法规</p>
                        </div>
                        <div class="tree">
                        <div style="height: 30px; width: 300px"></div>
                        <div class="treeone" v-for="(item, index) in tr" :key="index">
                            <div class="treeoneone" @click.stop="getzhan(item)" :class="{actyifenlei:item.if==true}">
                            <p
                                style="
                                margin-left: 20px;
                                display: flex;
                                align-items: center;
                                flex-wrap: wrap;
                                /* padding: 5px 0; */
                                "
                                :class="{actyifenleiwenzi:item.if==true}"
                            >
                                {{ item.name }} &nbsp;<span
                                style="font-size: 14px; color: #c22424"
                                >({{ item.count }})</span
                                >
                            </p>
                            <div class="zhan">
                                {{ item.if == false ? "展开" : "收起" }}
                            </div>
                            </div>

                            <div class="treetwo" v-if="item.if">
                            <div
                                @click.stop="geterzhan(it, item)"
                                class="treethree"
                                v-for="(it, index) in item.tags"
                                :key="index"
                            >
                                <div style="display: flex; align-items: center; padding: 5px 0">
                                <p class="treethreexian"></p>
                                <p class="erjia" v-if="it.children != null">
                                    {{ it.erif == false ? "+" : "-" }}
                                </p>
                                <p
                                    style="
                                    margin-left: 5px;
                                    display: flex;
                                    align-items: center;
                                    flex-wrap: wrap;
                                    padding: 5px 0;
                                    "
                                    :class="{ actcheck: checkId == it.id }"
                                >
                                    {{ it.name }} &nbsp;<span
                                    style="font-size: 14px; color: #c22424"
                                    >({{ it.count }})</span
                                    >
                                </p>
                                </div>

                                <div class="sanji" v-if="it.children != null">
                                <div class="sanjione" v-if="it.erif">
                                    <div
                                    class="sanjihang"
                                    v-for="(ii, index) in it.children"
                                    :key="index"
                                    @click.stop="getsanji(ii, it, item)"
                                    >
                                    <p class="treethreexian"></p>
                                    <p
                                        style="
                                        margin-left: 5px;
                                        display: flex;
                                        align-items: center;
                                        flex-wrap: wrap;
                                        padding: 5px 0;
                                        "
                                        :class="{ actcheck: checkIdsan == ii.id }"
                                    >
                                        <span>{{ ii.name }} </span>&nbsp;<span
                                        style="font-size: 14px; color: #c22424"
                                        >({{ ii.count }})</span
                                        >
                                    </p>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                <div class="fpLeftBottomRight">
                    <div class="right">
                        <div class="rightone" v-if="(fenbianlvType == false&&fpList.length==1)||(fenbianlvType == true)">
                        <p style="font-size: 18px; color: #124baa; margin-left: 30px">
                            现行有效法规:
                        </p>
                        <div
                            class="rione"
                            v-for="(it, index) in xl"
                            :key="index"
                            :class="{ actrione: xlIdone == it.id }"
                            @click="getfg(it)"
                        >
                            {{ it.name }}
                        </div>
                        </div>
                        <div class="rightone" v-if="(fenbianlvType == false&&fpList.length==1)||(fenbianlvType == true)">
                        <p style="font-size: 18px; color: #124baa; margin-left: 30px">
                            明确失效法规:
                        </p>
                        <div
                            class="rione"
                            v-for="(it, index) in xlone"
                            :key="index"
                             :class="{ actrione: xlIdone == it.id }"
                            @click="getfg(it)"
                        >
                            {{ it.name }}
                        </div>
                        </div>
                        <div class="rightone riri" v-if="(fenbianlvType == false&&fpList.length==1)||(fenbianlvType == true)">
                        <p style="font-size: 18px; color: #124baa; margin-left: 30px">
                            尚未生效法规:
                        </p>
                        <div
                            class="rione"
                            v-for="(it, index) in xltwo"
                            :key="index"
                            :class="{ actrione: xlIdone == it.id }"
                            @click="getfg(it)"
                        >
                            {{ it.name }}
                        </div>
                        </div>
                        <div class="rightone riri" v-if="ids == 1">
                        <div
                            :class="{ actrionetwo: hangId == it.id }"
                            class="rionetwo"
                            v-for="(it, index) in hang"
                            :key="index"
                            @click="gethang(it)"
                        >
                            {{ it.name }}
                        </div>
                        </div>
                        <div class="rightonewai">
                           <div class="rightone" v-if="(fenbianlvType == false&&fpList.length>1)">
                        <p style="font-size: 18px; color: #124baa; margin-left: 30px">
                            现行有效法规:
                        </p>
                        <div
                            class="rione"
                            v-for="(it, index) in xl"
                            :key="index"
                            :class="{ actrione: xlIdone == it.id }"
                            @click="getfg(it)"
                        >
                            {{ it.name }}
                        </div>
                        </div>
                        <div class="rightone" v-if="(fenbianlvType == false&&fpList.length>1)">
                        <p style="font-size: 18px; color: #124baa; margin-left: 30px">
                            明确失效法规:
                        </p>
                        <div
                            class="rione"
                            v-for="(it, index) in xlone"
                            :key="index"
                             :class="{ actrione: xlIdone == it.id }"
                            @click="getfg(it)"
                        >
                            {{ it.name }}
                        </div>
                        </div>
                        <div class="rightone riri" v-if="(fenbianlvType == false&&fpList.length>1)">
                        <p style="font-size: 18px; color: #124baa; margin-left: 30px">
                            尚未生效法规:
                        </p>
                        <div
                            class="rione"
                            v-for="(it, index) in xltwo"
                            :key="index"
                            :class="{ actrione: xlIdone == it.id }"
                            @click="getfg(it)"
                        >
                            {{ it.name }}
                        </div>
                        </div>
                        <div class="rightone riri" v-if="ids == 1">
                        <div
                            :class="{ actrionetwo: hangId == it.id }"
                            class="rionetwo"
                            v-for="(it, index) in hang"
                            :key="index"
                            @click="gethang(it)"
                        >
                            {{ it.name }}
                        </div>
                        </div>
                        </div>
                        
                        <div class="ritwo" v-if="totaltol != 0">
                        <div
                            class="rithree"
                            v-for="(it, index) in list"
                            :key="index"
                            @click="getDetail(it)"
                        >
                            <div style="display: flex; align-items: center; margin-top: 15px">
                            <img
                                src="../../assets/dian.png"
                                alt=""
                                style="width: 8px; height: 8px; margin-right: 6px"
                            />
                            <p class="tifour" v-html="it.title"></p>
                            </div>
                            <p class="riwu">
                            <span v-if="it.editor != null">{{ it.editor }} / </span>
                            <span v-if="it.publishDate != null"> {{ it.publishDate }} / </span>
                          <span v-if="it.modelId == 'fagui' && it.xlfw !=null">{{it.xlfw=='全文失效'?'全文废止':it.xlfw }}</span>
                            </p>
                        </div>
                        </div>
                        <div
                        v-if="totaltol != 0"
                        style="
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            padding-bottom: 30px;
                        "
                        >
                        <div class="fenye" v-if="fenbianlvType == true&&fpList.length<2">
                            <div
                            @click="getpage(1)"
                            :class="{ actfenye: pageIndex == 1 }"
                            class="fenoneone"
                            >
                            首页
                            </div>
                            <el-pagination
                            background
                            layout="prev, pager, next"
                            :page-size="pageSize"
                            :total="totaltol"
                            next-text="下一页"
                            prev-text="上一页"
                            @current-change="handleCurrentChange"
                            :current-page="pageIndex"
                            >
                            </el-pagination>
                            <div
                            @click="getpage(4)"
                            :class="{ actfenye: pageIndex == Math.ceil(this.totaltol / 10) }"
                            class="fenoneone"
                            >
                            尾页
                            </div>
                        </div>
                        <div class="fenye" v-if="(fenbianlvType == false&&fpList.length==1)||(fenbianlvType == true&&fpList.length>1)">
                            <div
                            @click="getpage(1)"
                            :class="{ actfenye: pageIndex == 1 }"
                            class="fenoneone"
                            >
                            首页
                            </div>
                            <el-pagination
                            background
                            layout="prev, next"
                            :page-size="pageSize"
                            :total="totaltol"
                            next-text="下一页"
                            prev-text="上一页"
                            @current-change="handleCurrentChange"
                            :current-page="pageIndex"
                            >
                            </el-pagination>
                            <div
                            @click="getpage(4)"
                            :class="{ actfenye: pageIndex == Math.ceil(this.totaltol / 10) }"
                            class="fenoneone"
                            >
                            尾页
                            </div>
                        </div>
                        </div>
                        <img
                        v-if="totaltol == 0"
                        src="../../assets/wu.png"
                        alt=""
                        style="width: 500px; height: 300px"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="fpRight" :class="rightClass">
            <div class="fpScroll" :class="('fpScroll' + fpList.length)">
                <div class="fpRightList" v-for="(itemFP,index) in fpList" :key="index">
                    <div class="fpDataTop">
                        <div class="fpDataTopLeft">第{{fpList.length - index}}页</div>
                        <div class="fpDataTopRight">
                            <div class="topRightQPXS" @click="gocontent(itemFP)">
                                <img :src="imgObj.allWindow" alt="">
                                全屏显示
                            </div>
                            <!-- <div class="topRightSC">
                                <img :src="imgObj.userSC" alt="">
                                收藏
                            </div> -->
                            <div class="topRightXZ" @click="wordDown(itemFP,index)">
                                <img :src="imgObj.down" alt="">
                                下载
                            </div>
                            <div class="topRightGB" @click="changeFPList(itemFP,'delete',index)">
                                <img :src="imgObj.close" alt="">
                                关闭
                            </div>
                        </div>
                    </div>
                    <div class="fpDataShow">
                        <div :id="'pdfContent'+index">
                            <div class="dataShowTitle" v-html="itemFP.title"></div>
                            <div class="dataShowInfo">
                                <div class="dataInfoList" v-if="itemFP.author">发文机关:{{itemFP.author}}</div>
                                <div class="dataInfoList" v-if="itemFP.editor">发文文号:{{itemFP.editor}}</div>
                                <div class="dataInfoList" v-if="itemFP.publishDate">发文日期:{{itemFP.publishDate.slice(0,10) | publishDate}}</div>
                                <div class="dataInfoList" v-if="itemFP.attribute&&itemFP.attribute.state">
                                    文件效力:
                                    <span style="color:#0f59a4;">{{statusType[itemFP.attribute.state]}}</span>
                                </div>
                            </div>
                            <div class="dataShowContent" v-html="imgUrl(itemFP.text)"></div>
                            <div class="typeBoxs" v-if="itemFP.FilesInfo&&itemFP.FilesInfo.length>0">
                                <div class="accessory">
                                <span style="margin-left:14px"> 附件:</span>
                                </div>
                                <div class="titleBox" v-for="item in itemFP.FilesInfo" @click="download(item.contentFilePath)">
                                <span class="title">{{item.title}}</span>
                                <span class="btn" style="cursor: pointer;">下载</span>
                                </div>
                            </div>
                            <div class="typeBoxs" v-if="itemFP.JDInfo&&itemFP.JDInfo.length>0">
                                <div class="accessory">
                                <span style="margin-left:14px">相关解读:</span>
                                </div>
                                <div class="titleBox" v-for="item in itemFP.JDInfo" @click="jumpC(item.id)">
                                <span class="title" style="cursor: pointer;">{{item.title}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div style="width: 100px; height: 100px"></div>
    <div class="footCommon">网站版权信息</div>
  <el-drawer
  :visible.sync="drawer"
  :direction="direction"
  :size="Size"
  :show-close=false>
  <div class="tan">
    <div class="tanone">
      <p style="font-size:20px;margin-left:45px">我的检索条件记录</p>
      <p @click="getfan" style="font-size:16px;margin-right:45px;cursor: pointer;">返回</p>
    </div>
    <div class="taner">
     <p style="margin-left:20px">检索条件</p>
     <p style="margin-left:430px">检索时间</p>
    </div>
    <div class="tansan" v-for="(item,index) in table" :key="index">
      <p class="tanzi" v-if="item.treename"><span style="margin-right:20px" v-for="(it,index) in item.jianname" :key="index">{{item.inputId==1?'正文':(item.inputId==2?'标题':'文号')}}{{(index+1)}} : {{it}}</span>{{item.treename}}</p>
      <p class="tanzi" v-if="item.tag"><span style="margin-right:20px" v-for="(it,index) in item.tag" :key="index">{{item.inputId==1?'正文':(item.inputId==2?'标题':'文号')}}{{(index+1)}} : {{it.name}}</span></p>
      <p>{{item.time}}</p>
      <div class="tansi" @click="getjian(item)">检索</div>
    </div>
  </div>
</el-drawer>
  </div>
</template>

<script>

import { HomeLaw, list, Cmsdetail ,keyLenovo,HomeAnalyzeKeyword} from "@/api/api.js";

//引入js
import  '@/assets/js/jquery.wordexport.js'

//节流
import { debounce } from 'lodash'

//引入图片
import allWindow from "@/assets/fp/allWindow.png"
import userSC from "@/assets/fp/userSC.png"
import down from "@/assets/fp/down.png"
import close from "@/assets/fp/close.png"


export default {
    filters:{
        publishDate(v){
        var date = new Date(v);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + ' ';
        var h = (date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours()) + ':';
        var m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) + ':';
        var s = (date.getSeconds() < 10 ? '0'+(date.getSeconds()) : date.getSeconds());
        return Y+M+D;
        //return Y+M+D+h+m+s;
        }
    },
  data() {
    return {
      index: "",
      input: "",
      fen:[],
      Size:'55%',
      checkId: "",
      checkIdsan: "",
      tagId:"",
      tagerId:"",
      tagsanId:"",
      drawer: false,
      keyword: "",
      drawer: false,
      direction: 'rtl',
      nav: true,
      table:[],
      sanId: "",
      loading: "",
      consultList: [],
      yifenleiId:"",
      inputId: "",
      xl: [
        { id: "xl", name: "全部" },
        { id: "qwyx", name: "全文有效" },
        { id: "bfyx", name: "部分有效" },
        { id: "tdsjyx", name: "特定时间有效" },
      ],
      xlone: [
        { id: "xlone", name: "全部" },
        { id: "qwsx", name: "全文废止" },
        { id: "bfsx", name: "部分失效" },
        { id: "tdsjsx", name: "特定时间失效" },
      ],
      xltwo: [{ id: "swsx", name: "全部" }],
      hangId: "1",
      ids: "",
      hang: [
        { id: 1, name: "国家税收法规" },
        { id: 2, name: "地方税收政策" },
        { id: 12, name: "中央部门法规" },
        { id: 20, name: "地方部门法规" },
      ],
      tr: [],
      xlId:["qwyx","bfyx","tdsjyx"], //效力Id
      xlIdone:"xl",
      pageIndex: 1,
      total: 0,
      totaltol: 0,
      pageSize: 10,
      dictionaryValues: {
        // type: "", //法规类型
        // state: this.xlId, //效力范围
      },
      tag: [],
      categoryId: "",
      name: "", //首页传过来的
      list: [],
      
        //分屏相关
        imgObj:{
            allWindow,
            userSC,
            down,
            close
        },
        statusType:{
            1:'有效法规',
            2:'失效法规',
            3:'部分失效',
            4:'-',
            5:'时效性',
        },
        //获取分辨率 判断是1900+么
        fenbianlvType:false,
        //分屏样式
        leftClass:'',
        rightClass:'',
        //获取的详情
        detailData:{},
        //分屏的数据
        fpList:[],
        //选择的联想词
        searchText:'',
        //联想词列表
        lenovoList:[],
        //历史检索
        historyList:[],
    };
  },
  created() {
    //获取 屏幕宽 分屏相关
    let windowWidth = document.body.clientWidth;
    this.fenbianlvType = windowWidth>1900?true:false
    console.log(this.fenbianlvType)
    //获取最近搜索
    this.getSearchHistory()

    this.loading = this.$loading({
      lock: true,
      text: "拼命加载中",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    this.name = this.$route.query.name;
    this.categoryId = this.$route.query.id;
    this.tagId = this.$route.query.id;
    this.keyword = this.$route.query.keyWord;
    this.input = this.$route.query.keyWord;
    this.inputId = this.$route.query.searchType;
    this.getfen()
    // this.total = parseInt(this.$route.query.count);
    if (this.$route.query.name == "按行业") {
      this.dictionaryValues.type = 1;
      this.ids = 1;
    }
    // this.consultList = JSON.parse(localStorage.getItem("consult"));
    console.log(this.$store.state, "ddddd");
    // this.getHomeLaw();
    this.tr = this.$store.state.fgList.childs;
    this.tr.map((it) => {
      if (it.id == this.categoryId) {
        this.total = it.count;
      }
    });
    setTimeout(() => {
      this.$forceUpdate();
      this.tr.map((item) => {
        // console.log(item, "item");
        if (this.$route.query.id == item.id) {
          item.if = true;
          this.name = item.name
        } else {
          item.if = false;
        }

        if (item.tags.length != 0 && item.tags != null) {
          item.tags.map((it) => {
            it.erif = false;
          });
        }
      });
    }, 800);

    setTimeout(() => {
      this.getlist();
    }, 1000);
  },
  beforeUpdate() {
    // console.log(this.$route);
    if (this.$route.path == "/nav") {
      this.loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      // debugger
      this.nav = false;
      this.loading.close();
    }
    // if (this.$route.query.keyWord != false) {
    //   this.index = this.$route.query.keyWord;
    // }
  },
  methods: {
    jump(v) {
      let url = process.env.VUE_APP_ZSG_URL + v;
      window.open(url, "_blank");
    },
    //附件下载
    download(v){
      if(v){
        let src = process.env.VUE_APP_DOWNLOAD_URL+v
        var $a = document.createElement('a');
        $a.setAttribute("href", src);
        $a.setAttribute("download", "");
        var evObj = document.createEvent('MouseEvents');
        evObj.initMouseEvent( 'click', true, true, window, 0, 0, 0, 0, 0, false, false, true, false, 0, null);
        $a.dispatchEvent(evObj);
      }else{
        this.$message({
          message: '当前附件未上传可下载文件！！！',
          type: 'warning'
        });
      }
    },
    imgUrl(v){
      let a = v;
      let b = new RegExp('src=\"/webfile/',"g")
      a = a.replace(b,'src=\"http://zsdy-data-admin.bjzsdy.com/webfile/');
      return a
    },
    navJump(v) {
      let Detail = this.$router.resolve({ path: "/nav", query: { id: v } });
      window.open(Detail.href, "_blank");
    },
    getfg(item) {
      //点击效力范围高亮
      this.pageIndex=1
      console.log(item,"kkkkk")
      if(item.id == 'xl'){
        this.xlIdone = item.id
      this.xlId=["qwyx","bfyx","tdsjyx"]
      this.getlist();
      }else if(item.id =="xlone"){
         this.xlIdone = item.id
        this.xlId=["qwsx","bfsx","tdsjsx"]
        this.getlist();
      }else{
         this.xlIdone = item.id
        this.xlId = [item.id];
      this.getlist();
      }
      
    },
    gethang(item) {
      this.pageIndex=1
      this.hangId = item.id;
      this.dictionaryValues.type = item.id;
      this.getlist();
    },
    getpage(item) {
      //分页
      this.pageId = item;
      if (item == 1) {
        this.pageIndex = 1;
        this.getlist();
      } else {
        this.pageIndex = Math.ceil(this.totaltol / 10);
        this.getlist();
      }
    },
    handleCurrentChange(item) {
      this.pageIndex = item;
      this.getlist();
    },
    getzhan(item) {
      //一级展开
       this.pageIndex=1
      this.$forceUpdate();
      this.tag = [];
      this.tagId = item.id
      this.tagerId = ""
      this.tagsanId = ""
      if (item.if == false && item.name != "按行业") {
        delete this.dictionaryValues.type;
        this.categoryId = item.id;
        this.total = parseInt(item.count);
        this.name = item.name;
        this.getlist();
      } else {
        // alert("收起");
        console.log(11);
      }
      // console.log(item, "one");
      if (item.name == "按行业" && item.if == false) {
        this.categoryId = item.id;
        this.dictionaryValues.type = this.hangId;
        this.name = item.name;
        this.getlist();
        this.total = parseInt(item.count);
        this.ids = 1;
      } else {
        delete this.dictionaryValues.type;
        this.ids = "";
      }
      item.if = !item.if;
      this.sanId = "";
    },
    geterzhan(it, item) {
       this.pageIndex=1
      this.$forceUpdate();
      this.tagId = item.id
      this.tagerId = it.id
      this.tagsanId = ""
      if (item.name == "按行业") {
        if (it.erif == false) {
          this.sanId = it.id;
          this.total = parseInt(it.count);
          this.dictionaryValues.type = this.hangId;
          this.categoryId = item.id;
          this.tag = [it.id];
          console.log(33);
          this.name = item.name + "—" + "—" + it.name;
          this.getlist();
          this.checkId = it.id;
          this.ids = 1;
        } else {
          console.log(111);
        }
      } else {
        // if (it.erif == false) {
          this.ids = "";
          // this.dictionaryValues.type = this.hangId;
          this.categoryId = item.id;
          this.total = parseInt(it.count);
          this.tag = [it.id];
          console.log(444);
          this.sanId = it.id;
          this.name = item.name + "—" + " " + it.name;
          this.getlist();
          this.checkId = it.id;
        // } else {
          // this.getlist();
        // }
      }
      //二级展开
      if (it.children != null) {
        it.erif = !it.erif;
      }
      console.log(it, item, "er");
    },
    getsanji(ii, it, item) {
       this.pageIndex=1
      console.log(ii, it, item, "san");
      this.total = parseInt(ii.count);
      this.sanId = it.id;
      this.tagId = item.id
      this.tagerId = it.id
      this.tagsanId = ii.id
      if (item.name == "按行业") {
        this.dictionaryValues.type = this.hangId;
        this.categoryId = item.id;
        this.tag = [ii.id];
        this.getlist();
        this.name = item.name + "—" + " " + it.name + "—" + " " + ii.name;
        this.checkIdsan = ii.id;
        this.ids = 1;
      } else {
        delete this.dictionaryValues.type;
        this.categoryId = item.id;
        this.tag = [ii.id];
        this.getlist();
        this.name = item.name + "—" + it.name + "—" + ii.name;
        this.checkIdsan = ii.id;
        this.ids = "";
      }
      //二级展开
      // it.erif = !it.erif;
    },
    getHomeLaw() {
      let str = [];
      str = this.$store.state.treeList.childs;
      str.push(this.$store.state.treeList.id);
         let kk = ""
      if(this.fen.length != 0){
      kk = this.fen.join(" ")
      }else{
        this.fen = [this.keyword]
      }
      let data = {
        articleNo: this.inputId == 3 ? (this.fen.length==0?this.keyword:kk) : "",
        content: this.inputId == 1 ? (this.fen.length==0?this.keyword:kk) : "",
        title: this.inputId == 2 ? (this.fen.length==0?this.keyword:kk) : "",
        needCategoryIds: str,
      };
      HomeLaw(data).then((res) => {
        console.log(res, "kkkkkkk");
        this.tr = res.data.data[0].childs;
        this.tr.map((item) => {
          // console.log(item, "item");
          if (this.$route.query.id == item.id) {
            item.if = true;
          } else {
            item.if = false;
          }

          if (item.tags.length != 0 && item.tags != null) {
            item.tags.map((it) => {
              it.erif = false;
            });
          }
        });
      });
    },
    async sousuo(item) {
        let str = this.input + ''
        await this.addSearchHistory(str)

      this.searchType = item;
      this.$router.push({
        path: "/index",
        query: {
          keyword: this.input,
          searchType: this.searchType,
        },
      });
      // this.inputId = item;
      // this.getHomeLaw();
      // this.getlist();
    },
    getlist() {
      this.loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      // this.dictionaryValues.state = this.xlId;
      let kk = ""
      if(this.fen.length != 0){
      kk = this.fen.join(" ")
      }else{
        this.fen = [this.keyword]
      }
      let data = {
        articleNo: this.inputId == 3 ? (this.fen.length==0?this.keyword:kk) : "",
        categoryId: this.categoryId,
        content: this.inputId == 1 ? (this.fen.length==0?this.keyword:kk) : "",
        page: this.pageIndex,
        size: this.pageSize,
        states: this.xlId,
        dictionaryValues: this.dictionaryValues,
        tagIds: this.tag,
        title: this.inputId == 2 ? (this.fen.length==0?this.keyword:kk) : "",
      };
      list(data).then((res) => {
        // console.log(res, "jjjjjjjj");
        if(res.data.data.contents){
           this.list = res.data.data.contents;
        this.totaltol = res.data.data.count;
        this.list.map((ii) => {
          ii.publishDate = ii.publishDate.slice(0, 10);
        });
        this.loading.close();
        }
       this.loading.close();
      });
    },
    getdel(kk,ii) {
       this.loading = this.$loading({
      lock: true,
      text: "拼命加载中",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
      console.log(kk,ii,"ssssss")
       this.pageIndex=1
       console.log(this.fen,"fen")
      if (ii == 1) {
        this.keyword = "";
        this.input = "";
        if(this.fen.length !=0){
        this.fen = this.fen.filter(oo=>oo !=kk)
        this.keyword = this.fen.join(" ")
        // console.log(this.keyword,'this.k')
        this.input = this.keyword
        let query = JSON.parse(JSON.stringify(this.$route.query));
        query.keyWord = this.keyword;
        query.searchType = this.inputId;
        if(this.fen.length ==0){
           query.searchType=""
        }
        this.$router.replace({ query: query }); 
        }
        this.$forceUpdate();
        setTimeout(()=>{
         let str = [];
      str = this.$store.state.treeList.childs;
      str.push(this.$store.state.treeList.id);
        let kk = ""
      if(this.fen.length != 0){
      kk = this.fen.join(" ")
      }else{
        this.fen = [this.keyword]
      }
      let data = {
        articleNo: this.inputId == 3 ? (this.fen.length==0?this.keyword:kk) : "",
        content: this.inputId == 1 ? (this.fen.length==0?this.keyword:kk) : "",
        title: this.inputId == 2 ? (this.fen.length==0?this.keyword:kk) : "",
        needCategoryIds: str,
      };
     HomeLaw(data).then((res) => {
        console.log(res, "kkkkkkk");
        this.tr = res.data.data[0].childs;
        this.xlId = ["qwyx","bfyx","tdsjyx"]
        this.xlIdone="xl",
        this.dictionaryValues={}
       if(this.categoryId==4019){
        this.ids = 1
        if(this.checkIdsan != ""){
        this.tag = [this.checkIdsan]
        this.tr.map(it=>{
        if(it.id==this.categoryId){
          it.if = true
          it.tags.map(ii=>{
          if(ii.id == this.checkId){
            ii.erif = true
            ii.children.map(ip=>{
              if(ip.id == this.checkIdsan)
            this.total = ip.count
              this.getlist()
            })
          }else{
            ii.erif = false 
          }
          })
        }else{
          it.if = false
        }
        })
      }else if(this.checkId !="" && this.checkIdsan==""){
        this.tag = [this.checkId]
        this.tr.map(it=>{
        if(it.id==this.categoryId){
          it.if = true
          it.tags.map(ii=>{
          if(ii.id == this.checkId){
            ii.erif = true
             this.total = ii.count
               this.getlist()
          }else{
            ii.erif = false 
          }
          })
        }else{
          it.if = false
        }
        })
      }else{
        this.ids = 1
        this.tag = []
        this.tr.map(it=>{
          if(it.id == this.categoryId){
            it.if = true
            this.tatal = it.count
              this.getlist()
          }else{
           it.if = false 
          }
        })
      }
       }
       if(this.categoryId==4021){
         this.ids = ""
        if(this.checkIdsan != ""){
        this.tag = [this.checkIdsan]
        this.tr.map(it=>{
        if(it.id==this.categoryId){
          it.if = true
          it.tags.map(ii=>{
          if(ii.id == this.checkId){
            ii.erif = true
            ii.children.map(ip=>{
              if(ip.id == this.checkIdsan)
            this.total = ip.count
              this.getlist()
            })
          }else{
            ii.erif = false 
          }
          })
        }else{
          it.if = false
        }
        })
      }else if(this.checkId !="" && this.checkIdsan==""){
        this.tag = [this.checkId]
        this.tr.map(it=>{
        if(it.id==this.categoryId){
          it.if = true
          it.tags.map(ii=>{
          if(ii.id == this.checkId){
            ii.erif = true
             this.total = ii.count
               this.getlist()
          }else{
            ii.erif = false 
          }
          })
        }else{
          it.if = false
        }
        })
      }else{
        this.tag = []
        this.tr.map(it=>{
          if(it.id == this.categoryId){
            it.if = true
            this.tatal = it.count
              this.getlist()
          }else{
           it.if = false 
          }
        })
      }
       }
       if(this.categoryId!=4019 && this.categoryId!=4021){
         this.ids = ""
      if(this.checkId !=""){
        this.tag = [this.checkId]
        this.tr.map(it=>{
        if(it.id==this.categoryId){
          it.if = true
          it.tags.map(ii=>{
          if(ii.id == this.checkId){
            ii.erif = true
             this.total = ii.count
               this.getlist()
          }else{
            ii.erif = false 
          }
          })
        }else{
          it.if = false
        }
        })
      }else{
        this.tag = []
        this.tr.map(it=>{
          if(it.id == this.categoryId){
            console.log(it,"jjjjjjjjj")
            it.if = true
            this.total = it.count
              this.getlist()
          }else{
           it.if = false 
          }
          
      if (it.tags.length != 0 && it.tags != null) {
                  it.tags.map((it) => {
                    it.erif = false;
                  });
                }
        })
      }
       }

        setTimeout(()=>{
          this.drawer = false
      },1200)
      });
      //  this.getlist()
      },1300)
        
       
      } else {
        this.$router.push({
          path: "/index",
          query: {
            keyword: this.keyword,
            searchType: this.inputId,
          },
        });
      }
    },
    getfen(){
      if(this.$route.query.keyWord !=""){
         let data ={
        keyword : this.keyword?this.keyword:" "
      }
      HomeAnalyzeKeyword(data).then(res=>{
        // console.log(res,"kkkkkk")
        this.fen = res.data.data
      })
      }
    },
    getji(){//记录
    this. drawer = true
    this.table = JSON.parse(localStorage.getItem("table"));
    console.log(this.table,"llllllll")
    },
     getbao(){//保存
        let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      if(day<10){
        day = '0'+day
      }
      let time = year +'-'+month +'-'+day;
      if (localStorage.getItem("table")) {
          let shuzuer = JSON.parse(localStorage.getItem("table"));
          let data={
          treename:this.name?'分类:'+'  '+ this.name:"",
          tagId:this.tagId.toString(),
          tagerId:this.tagerId?this.tagerId.toString():"",
          tagsanId:this.tagsanId?this.tagsanId.toString():"",
          inputId:this.inputId?this.inputId:'',
          jianname:this.fen.length==0?[this.keyword]:this.fen,
          time:time
        }
          shuzuer.push(data);
          if (shuzuer.length == 6) {
            shuzuer.shift();
          }
          localStorage.setItem("table", JSON.stringify(shuzuer));
        } else {
          let shuzuer = [];
           let data={
          treename:this.name?'分类:'+ this.name:"",
          tagId:this.tagId.toString(),
          tagerId:this.tagerId?this.tagerId.toString():"",
          tagsanId:this.tagsanId?this.tagsanId.toString():"",
          inputId:this.inputId?this.inputId:'',
          jianname:this.fen.length==0?[]:this.fen
        }
          shuzuer.push(data);
          localStorage.setItem("table", JSON.stringify(shuzuer));
        }
       this.$message({
          message: '保存成功，可点击“记录”，查看已保存的检索条件',
          type: 'success'
        });
    },
    getfan(){//记录
    this.drawer = false
    },
    getjian(item){
      if(item.tag){
       this.$router.push({
          path: "/index",
          query: {
            keyword: item.tag[0].name,
            searchType: this.inputId,
          },
        });
      }else{
    this.checkId=""
    this.checkIdsan=""
    this.inputId = item.inputId
    this.fen = item.jianname
    this.name = item.treename
    this.name = this.name.replaceAll('分类:',"")
    if(item.jianname.length !=0){
      this.keyword = item.jianname.join(" ")
       this.input =  this.keyword
         let query = JSON.parse(JSON.stringify(this.$route.query));
        query.keyWord = this.keyword;
        query.searchType=item.inputId;
        query.id = item.tagId
        query.count = ""
        query.name = ""
        this.$router.replace({ query: query }); 
    }else{
       this.keyword = ""
       this.input =  this.keyword
         let query = JSON.parse(JSON.stringify(this.$route.query));
        query.keyWord = this.keyword;
         query.searchType=item.inputId;
        query.id = item.tagId
        query.count = ""
        query.name = ""
        this.$router.replace({ query: query }); 
    }
     let str = [];
      str = this.$store.state.treeList.childs;
      str.push(this.$store.state.treeList.id);
         let kk = ""
      if(this.fen.length != 0){
      kk = this.fen.join(" ")
      }else{
        this.fen = [this.keyword]
      }
      let data = {
        articleNo: this.inputId == 3 ? (this.fen.length==0?this.keyword:kk) : "",
        content: this.inputId == 1 ? (this.fen.length==0?this.keyword:kk) : "",
        title: this.inputId == 2 ? (this.fen.length==0?this.keyword:kk) : "",
        needCategoryIds: str,
      };
      HomeLaw(data).then((res) => {
        console.log(res, "kkkkkkk");
        this.tr = res.data.data[0].childs;
        this.xlId = ["qwyx","bfyx","tdsjyx"]
        this.xlIdone="xl",
        this.dictionaryValues={}
       if(item.tagId==4019){
        this.categoryId = item.tagId
        this.ids = 1
        if(item.tagsanId != ""){
        this.tag = [item.tagsanId]
        this.tr.map(it=>{
        if(it.id==item.tagId){
          it.if = true
          it.tags.map(ii=>{
          if(ii.id == item.tagerId){
            ii.erif = true
            this.checkId = item.tagerId
            ii.children.map(ip=>{
              if(ip.id == item.tagsanId)
            this.total = ip.count
            this.checkIdsan = item.tagsanId?item.tagsanId:""
              this.getlist()
            })
          }else{
            ii.erif = false 
          }
          })
        }else{
          it.if = false
        }
        })
      }else if(item.tagerId !="" && item.tagsanId==""){
        this.tag = [item.tagerId]
        this.tr.map(it=>{
        if(it.id==item.tagId){
          it.if = true
          it.tags.map(ii=>{
          if(ii.id == item.tagerId){
            ii.erif = true
            this.checkId = item.tagerId
             this.total = ii.count
               this.getlist()
          }else{
            ii.erif = false 
          }
          })
        }else{
          it.if = false
        }
        })
      }else{
        this.categoryId = item.tagId
        this.ids = 1
        this.tag = []
        this.tr.map(it=>{
          if(it.id == item.tagId){
            it.if = true
            this.tatal = it.count
              this.getlist()
          }else{
           it.if = false 
          }
        })
      }
       }
       if(item.tagId==4021){
        this.categoryId = item.tagId
        if(item.tagsanId != ""){
        this.tag = [item.tagsanId]
        this.tr.map(it=>{
        if(it.id==item.tagId){
          it.if = true
          it.tags.map(ii=>{
          if(ii.id == item.tagerId){
            ii.erif = true
            this.checkId = item.tagerId
            ii.children.map(ip=>{
              if(ip.id == item.tagsanId)
            this.total = ip.count
            this.checkIdsan = item.tagsanId?item.tagsanId:""
              this.getlist()
            })
          }else{
            ii.erif = false 
          }
          })
        }else{
          it.if = false
        }
        })
      }else if(item.tagerId !="" && item.tagsanId==""){
        this.tag = [item.tagerId]
        this.tr.map(it=>{
        if(it.id==item.tagId){
          it.if = true
          it.tags.map(ii=>{
          if(ii.id == item.tagerId){
            ii.erif = true
            this.checkId = item.tagerId
             this.total = ii.count
               this.getlist()
          }else{
            ii.erif = false 
          }
          })
        }else{
          it.if = false
        }
        })
      }else{
        this.categoryId = item.tagId
        this.tag = []
        this.tr.map(it=>{
          if(it.id == item.tagId){
            it.if = true
            this.tatal = it.count
              this.getlist()
          }else{
           it.if = false 
          }
        })
      }
       }
       if(item.tagId!=4019 && item.tagId!=4021){
      if(item.tagerId !=""){
        this.tag = [item.tagerId]
          this.categoryId = item.tagId
        this.tr.map(it=>{
        if(it.id==item.tagId){
          it.if = true
          it.tags.map(ii=>{
          if(ii.id == item.tagerId){
            ii.erif = true
            this.checkId = item.tagerId
             this.total = ii.count
               this.getlist()
          }else{
            ii.erif = false 
          }
          })
        }else{
          it.if = false
        }
        })
      }else{
       this.categoryId = item.tagId
        this.tag = []
        this.tr.map(it=>{
          if(it.id == item.tagId){
            it.if = true
            this.total = it.count
              this.getlist()
          }else{
           it.if = false 
          }
          
      if (it.tags.length != 0 && it.tags != null) {
                  it.tags.map((it) => {
                    it.erif = false;
                  });
                }
        })
      }
       }

        setTimeout(()=>{
          this.drawer = false
      },1200)
      });
      }
    
    },
    //联想词点击
    lenovoCheck(item){
        //console.log(item);    
        this.input = item.entry
    },
    //搜索联想词
    fillHotWords: debounce(function () {
        if(this.input === ''){
            this.lenovoList = [];
            this.searchText = '';
            return
        }
        //获取接口
        let data = {
            "keyword": this.input,
            "page": 1,
            "size": 20
        }
        keyLenovo(data).then(res => {
            if(res.status==200&&res.data.status==0){
                this.lenovoList = res.data.rows;
                 this.searchText = this.input
                this.$nextTick(function(){
                   
                    this.mathLenovo();
                })
            }
        }).catch(err => {
            console.log(err)
        })
    },500),
    //获取最近检索
    getSearchHistory(){
        let thatStr = this.$cookies.get("zsdy-gw-history")
        if(thatStr!=null){
            localStorage.setItem('zsdy-gw-history',thatStr);
        }
        let thatStroage = localStorage.getItem('zsdy-gw-history');
        if(thatStroage){
            this.historyList = JSON.parse(thatStroage);
            this.$nextTick(function(){
                this.mathSearch();
            })
        }
    },
    //存储检索词
    addSearchHistory(text){
         //获取缓存数据
        let thatHistory = [];
        let thatStr = this.$cookies.get("zsdy-gw-history")
        console.log(thatStr)
        thatStr = JSON.parse(thatStr);
        //判断是否存在
        if(thatStr){
            thatHistory = thatStr
            for(let i=(thatHistory.length - 1);i>-1;i--){
                if(thatHistory[i] == text){
                    thatHistory.splice(i,1);
                }
            }
        }
        if(thatHistory.length>=20){
            thatHistory =   thatHistory.slice(0,9);
        }
        let thatText  = encodeURIComponent(text);
        thatHistory.unshift(thatText)
        console.log(thatHistory)
        document.cookie = "zsdy-gw-history="+JSON.stringify(thatHistory);
        this.getSearchHistory();
    },
    //历史记录点击
    historyClick(text){
        this.input = text
    },
    //计算最近检索词的长度
    mathSearch(){
        //获取
        let wNum = 0;
        let wArr = document.getElementsByClassName('textListHistory');
        for(let a=0;a<wArr.length;a++){
            wNum+= wArr[a].clientWidth
        }
        let wDom = document.getElementsByClassName('sHistoryScroll')[0];
        wDom.style.width = wNum + 20 + 'px'
    },
    //计算联想词的长度
    mathLenovo(){
        //获取
        let wNum = 0;
        let wArr = document.getElementsByClassName('textList');
        for(let a=0;a<wArr.length;a++){
            wNum+= wArr[a].clientWidth
        }
        let wDom = document.getElementsByClassName('sLenovoScroll')[0];
        wDom.style.width = wNum + 20 + 'px'
    },
    //点击获取详情
    getDetail(item){
        //获取数组长度
        if(this.fpList.length>=5){
            this.$message({
                message:'您已经打开了五条数据',
                type:'warning'
            })
            return
        }
        //判断当前id是否存在
        let isHave = this.fpList.some(ii=>ii.id==item.id)
        if(isHave){
            this.$message({
                message:'您已经打开当前数据',
                type:'warning'
            })
            return
        }
        //调用详情接口
        this.loading = this.$loading({
            lock: true,
            text: '拼命加载中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
            });
        let data = {
            id:item.id+'',
            keyWord:this.input
        }
        Cmsdetail(data).then(res => {
            this.detailData = res.data.data
            this.loading.close();
            this.changeFPList(this.detailData,'add')
        })
        
    },
    //修改分屏渲染的数据列表
    changeFPList(item,type,index){
        if(type == 'add'){
            this.fpList.unshift(item)
        }else if(type == 'delete'){
            this.fpList.splice(index,1)
        }
        //判断数组长度
        if(this.fpList.length==1){
            this.leftClass = "fpOneLeft";
            this.rightClass = "fpOneRight";

        }else if(this.fpList.length>1){
            this.leftClass = "fpMoreLeft";
            this.rightClass = "fpMoreRight";
        }
    },
    //新增word下载方法
    wordDown(item,index){
        let thatView  = '#pdfContent' + index
        let fileName = item.title
        $(thatView).wordExport(fileName);
    },
    jumpC(v){
      let Detail = this.$router.resolve({path:'/content',query:{contentId:v,keyWord:this.input}})
      window.open(Detail.href,'_blank')
    },
    gocontent(item) {
      console.log(item);
      let routeData = this.$router.resolve({
        path: "/content",
        query: {
          contentId: item.id,
          keyword: this.input,
        },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.hea {
  width: 1200px;
  min-height: 60px;
  background: #fff !important;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
}

.heaone {
  font-size: 16px;
  color: #0f59a4;
  font-weight: bold;
  margin-left: 20px;
}

.heatwo {
  max-width: 150px;
  min-height: 30px;
  border: 1px solid #dcdcdc;
  font-size: 14px;
  color: #333;
  display: flex;
  align-items: center;
  // border-radius: 10px;
   margin: 8px 0;
     margin-left: 15px;
     line-height: 1.5;
}

.headel {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #0f59a4;
  cursor: pointer;
}

.heaqingkong {
  margin-right: 20px;
  font-size: 16px;
  // background: #f65428;
}

.heachang {
  max-width: 680px;
  word-wrap:break-word;
}


/***************************分屏的样式 start************************** start*/
.fp{
    width: 100%;
    height: auto;
    display: flex;
    margin: 0 auto;
    margin-top: 20px;
    background: #f8f8f8;
    box-sizing: border-box;
    padding: 0 20px 20px 20px;
    /**分一屏 */
    .fpOneLeft{
        width:calc(100% - 480px);
        
        float:left;
    }
    .fpOneRight{
        width:480px;
        float:left;
    }
    /**分多屏 */
    .fpMoreLeft{
        width:calc(100% - 900px);
        float:left;
    }
    .fpMoreRight{
        width:900px;
        float:left;
    }
    /***分屏左  start*/
    .fpLeft{
        float:left;
        /***左边上边检索条件 start*/
        .fpLeftTop ::v-deep .hea{
            width: 100%;
        }
        .fpLeftTop{
            margin-bottom:10px;
        }
        /***左边上边检索条件 end*/
        /***左边下边检索条件 start*/
        .fpLeftBottom{
            /***左边下边左边检索条件 start*/
            .fpLeftBottomLeft{
                width:340px;
                float:left;
            }
            /***左边下边左边检索条件 end*/
            /***左边下边右边检索条件 start*/
            .fpLeftBottomRight ::v-deep .right,.rightone,.ritwo,.rithree{
                width:calc(100% - 10px);
            }
            
            .fpLeftBottomRight{
                width: calc(100% - 340px);
                overflow: hidden;
                float:left;
            }
            /***左边下边右边检索条件 end*/
            
        }
        /***左边下边检索条件 end*/
    }
    /***分屏左  end*/

    /***分屏右  start*/
    .fpRight{
        box-sizing: border-box;
        padding-left:10px;
        overflow-x: auto;
        .fpScroll1{
            width: 100%;
            .fpRightList{
                width:100%;
            }
        }
        .fpScroll2{
            width: 100%;
            .fpRightList{
                width:calc(50% - 1px);
                margin-right:1px;
            }
        }
        .fpScroll3{
            width: 150%;
            .fpRightList{
                width:calc(33.3% - 1px);
                margin-right:1px;
            }
        }
        .fpScroll4{
            width: 200%;
            .fpRightList{
                width:calc(25% - 1px);
                margin-right:1px;
            }
        }
        .fpScroll5{
            width: 250%;
            .fpRightList{
                width:calc(20% - 1px);
                margin-right:1px;
            }
        }
        .fpScroll{

        }
        .fpRightList{
            float:left;
            .fpDataTop{
                width:100%;
                height:40px;
                background: #0f59a4;
                box-sizing: border-box;
                padding:10px 0 12px 20px;
                color:#ffffff;
                display: flex;
                .fpDataTopLeft{
                    width:calc(100% - 266px);
                }
                .fpDataTopRight{
                    width: 266px;
                    display: flex;
                    text-align: left;
                    img{
                        width:16px;
                        height:16px;
                        position: relative;
                        top:1px;
                        margin-right:8px;
                    }
                    .topRightQPXS{
                        width:110px;
                        height:16px;
                        line-height: 14px;
                        cursor:pointer;
                    }
                    .topRightSC{
                        width:94px;
                        height:16px;
                        line-height: 14px;
                        cursor:pointer;
                    }
                    .topRightXZ{
                        width:78px;
                        height:16px;
                        line-height: 14px;
                        cursor:pointer;
                    }
                    .topRightGB{
                        width:78px;
                        height:16px;
                        line-height: 14px;
                        cursor:pointer;
                    }
                }
            }
            .fpDataShow{
                width:100%;
                height:1296px;
                background: #ffffff;
                overflow: auto;
                box-sizing: border-box;
                padding:30px 20px;
                .dataShowTitle{
                    text-align: center;
                    color:#000000;
                    font-size: 18px;
                    line-height: 36px;
                    font-weight: 700;
                }
                .dataShowInfo{
                    width:100%;
                    border-bottom:2px solid #d8d8d8;
                    margin-top:20px;
                    .dataInfoList{
                        width: 100%;
                        font-size: 16px;
                        color:#888888;
                        line-height: 24px;
                        margin-bottom:20px;
                    }
                }
                .dataShowContent ::v-deep table{
                    width: 100%!important;
                }
                .dataShowContent ::v-deep img{
                    width: 100%!important;
                }
                .dataShowContent{
                    padding-top: 16px;
                    border-top: 2px solid #d8d8d8;
                    font-size: 16px;
                    font-weight: normal;
                    line-height: 32px;
                    letter-spacing: 0em;
                    color: #3D3D3D;
                    padding-bottom: 40px;
                }
                .typeBoxs{
                    .accessory{
                    width: 100%;
                    height: 40px;
                    line-height: 40px;
                    border-left: 6px solid #003fa8;
                    background: #EEF8FF;
                    font-size: 16px;
                    font-weight: bold;
                    letter-spacing: 0em;
                    color: #3D3D3D;
                    margin-bottom: 15px;
                    }
                    .titleBox{
                    width: calc(100% - 11px);
                    padding-left: 11px;
                    // height: 30px;
                    margin-bottom: 10px;
                    .title{
                        font-size: 16px;
                        font-weight: normal;
                        line-height: 30px;
                        letter-spacing: 0em;
                        color: #0000FF;
                    }
                    .btn{
                        width: 60px;
                        height: 30px;
                        font-size: 14px;
                        font-weight: normal;
                        line-height: 30px;
                        letter-spacing: 0em;
                        color: #fff;
                        border-radius: 4px;
                        background: #003FA8;
                        display: inline-block;
                        text-align: center;
                        float: right;
                        
                    }
                    }
                }
            }
        }
    }
    .fpLeftBottomRight .rightonewai .rightone{
      max-width: 850px;
      background: #fff;
      min-height: 80px;
      display: flex;
      align-items: center;
      flex-direction: column;
      border-bottom: 1px solid #dcdcdc;
      flex-wrap: wrap;
      padding: 20px 0;
    }
     .fpLeftBottomRight .rightonewai .rightone .rione{
       width: 100px;
        height: 36px;
        background: #f8f8f8;
        font-size: 16px;
        color: #000000;
        text-align: center;
        line-height: 36px;
        margin: 10px 0;
        margin-left: 20px;
        cursor: pointer;
    }
  .fpLeftBottomRight .rightonewai .rightone .actrione {
  color: #fff;
  background: #0f59a4;
}

    /***分屏右  end*/

    

}
/***************************分屏的样式 start************************** end*/


.con {
  width: 1200px;
  height: auto;
  display: flex;
  margin: 0 auto;
  margin-top: 20px;
  background: #f8f8f8;
}

.left {
  width: 340px;
}

.leftone {
  width: 340px;
  height: 5px;
  background: #0f59a4;
}

.lefttwo {
  width: 340px;
  height: 80px;
  border-bottom: 1px solid #dcdcdc;
  background: #fff;
  // margin-bottom: 30px;
}

.lefttwowenzi {
  font-size: 22px;
  color: #0f59a4;
  font-weight: bold;
  line-height: 80px;
  margin-left: 20px;
}
.tree {
  width: 340px;
  height: auto;
  background: #fff;
  overflow: hidden;
}
.treeone {
  width: 300px;
  //   height: 50px;
  margin-left: 20px;
  margin-bottom: 20px;
}
.treeoneone {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8f8f8;
  cursor: pointer;
}
.treetwo {
  width: 280px;
  margin-left: 20px;
  max-height: 200px !important;
  overflow-y: scroll;
  margin-top: 10px;
  border-left: 1px solid #999999;
  // background: cyan;
}
/* 整个滚动条 */
::-webkit-scrollbar {
  width: 4px;
  height: 6px;
  background-color: #eeeeee;
}

/* 滚动条上的滚动滑块 */
::-webkit-scrollbar-thumb {
    background-color: #c6c6c6;
}
.treethree .erjia {
  font-size: 18px !important;
  color: #124baa !important;
  margin-bottom: 5px;
  cursor: pointer;
  margin-left: 5px;
  margin-top: 2px;
}
.treethreexian {
  width: 16px;
  height: 1px;
  padding: 0 !important;
  background: #999999;
}
.treethree {
  min-height: 34px;
  cursor: pointer;
  //   background: pink;
}
.treethree p {
  padding: 0 !important;
  font-size: 14px !important;
  color: #333333;
}
.sanji {
  //   width: 100px;
  height: auto;
  // background: greenyellow;
}
.sanjione {
  //   width: 100px;
  //   height: 50px;
  // background: red;
  margin-left: 20px;
  border-left: 1px solid #999999;
}
.sanjihang {
  height: 34px !important;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 5px 0 !important;
}
.treeone p {
  font-size: 18px;
  color: #000000;
  padding: 15px 0;
}
.zhan {
  font-size: 14px;
  color: #fff;
  width: 32px;
  height: 20px;
  background: #719fad;
  line-height: 20px;
  text-align: center;
  border-radius: 4px;
  margin-right: 20px;
  cursor: pointer;
}
.right {
  width: 850px;
  height: auto;
  margin-left: 10px;
  background: #fff;
}

.rightone {
  background: #fff;
  width: 850px;
  min-height: 80px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #dcdcdc;
}

.rione {
  width: 100px;
  height: 36px;
  background: #f8f8f8;
  font-size: 16px;
  color: #000000;
  text-align: center;
  line-height: 36px;
  margin-left: 20px;
  cursor: pointer;
}

.actrione {
  color: #fff;
  background: #0f59a4;
}

.ritwo {
  width: 850px;
  height: auto;
  margin-top: 10px;
  background: #fff;
}
.actcheck {
  color: #124baa !important;
}
.rithree {
  width: 820px;
  height: 90px;
  margin-left: 20px;
  margin-right: 10px;
  // background: cyan;
  border-bottom: 1px dotted #eeeeee;
  overflow: hidden;
  cursor: pointer;
}

.tifour {
  width: 740px;
  font-size: 16px;
  color: #333333;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.riwu {
  margin-top: 15px;
  color: #888888;
  font-size: 14px;
  margin-left: 15px;
}

.fenye {
  height: auto;
  margin-top: 20px;
  display: flex;
  align-items: center;
  // margin-left: 400px;
}

.fenye ::v-deep .el-pagination.is-background .el-pager li {
  border-radius: 0;
  background: #fff;
  height: 38px;
  line-height: 38px;
  border: 1px solid #124baa;
}

.fenye ::v-deep .el-pager li {
  font-size: 16px;
}

.fenye ::v-deep .el-pagination.is-background .btn-next,
.fenye ::v-deep .el-pagination.is-background .btn-prev,
.fenye ::v-deep .el-pagination.is-background .el-pager li {
  background: #fff;
  border-radius: 0;
}

.fenye ::v-deep .el-pagination.is-background .btn-next.disabled,
.fenye ::v-deep .el-pagination.is-background .btn-next:disabled,
.fenye ::v-deep .el-pagination.is-background .btn-prev.disabled,
.fenye ::v-deep .el-pagination.is-background .btn-prev:disabled,
.fenye ::v-deep .el-pagination.is-background .el-pager li.disabled {
  color: #124baa;
}

.fenye
  ::v-deep
  .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background: #124baa;
  color: #fff;
}

.fenye ::v-deep .el-pagination.is-background .btn-next,
.fenye ::v-deep .el-pagination.is-background .btn-prev,
.fenye ::v-deep .el-pagination.is-background .el-pager li {
  color: #124baa;
}

.fenye ::v-deep .btn-prev {
  width: 80px;
  height: 38px;
  background: #fff;
  border-radius: 0;
  border: 1px solid #124baa;
}

.fenye ::v-deep .btn-next {
  width: 80px;
  height: 38px;
  background: #fff;
  border-radius: 0;
  border: 1px solid #124baa;
}

.fenye ::v-deep .el-pagination button,
.fenye ::v-deep .el-pagination span:not([class*="suffix"]) {
  font-size: 16px;
}

.fenone {
  max-width: 500px;
  // height: 36px;
  line-height: 36px;
  text-align: center;
  font-size: 16px;
  flex-wrap: wrap;
  // border: 1px solid #124baa;
  color: #124baa;
  cursor: pointer;
}
.fenoneone{
   width: 80px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  font-size: 16px;
  border: 1px solid #124baa;
  color: #124baa;
  cursor: pointer;

}
.actfenye {
  color: #fff;
  background: #124baa;
}
.rionetwo {
  width: 140px;
  height: 36px;
  background: #f8f8f8;
  font-size: 16px;
  color: #000000;
  text-align: center;
  line-height: 36px;
  margin-left: 20px;
  cursor: pointer;
}
.actrionetwo {
  background: #0f59a4;
  color: #fff;
}
.index {
  width: 100%;
}

.topCommon {
  width: 100%;
  height: 140px;
  background: #003fa8;
}

.footCommon {
  width: 100%;
  height: 156px;
  background: #0f59a4;
  font-size: 42px;
  font-weight: normal;
  line-height: 156px;
  letter-spacing: 0em;
  color: #ffffff;
  text-align: center;
}

.midCommon {
  width: 1200px;
  padding: 0 calc((100% - 1200px) / 2);
  background: #f5f5f5;
  padding-top: 20px;
}

.logo {
  width: 1200px;
  height: 140px;
  margin: 0 auto;
  position: relative;
}

.logo img {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.topBox {
  width: 100%;
  height: 315px;
  padding: 50px 0 60px;
  margin: 0 auto;
  background: #f3f8fc;

  img {
    cursor: pointer;
  }
}

.search {
  // padding: 0 70px;
  // margin-bottom: 45px;
  width: 1000px;
  // margin: 0 auto 45px;
  height: 60px;
  margin-top: 50px;
  position: relative;
}
/**搜索联想 */
.searchLenovo{
    max-width:710px;
    height: 40px;
    line-height: 40px;
    position: absolute;
    top:64px;
    left:0;
    .sLevovoTitle{
        width:70px;
        height:40px;
        float:left;
        color:#333333;
    }
    .sLevovoKey{
        min-width:1px;
        max-width: 160px;
        height:40px;
        float:left;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
    }
    .sLevovoRight{
        width:480px;
        height:50px;
        float:left;
        overflow-x: auto;
        overflow-y: hidden;
        color:#888888;
        .sLenovoScroll{
            font-size:15px;
        }
         .sLenovoScroll1{
            font-size:15px;
        }
        .textList{
            display: inline-block;
            padding:0 10px;
            cursor:pointer;
        }
    }
}
.searchHistory{
    max-width:710px;
    height: 40px;
    line-height: 40px;
    position: absolute;
    top:64px;
    left:0;
    .sHistoryTitle{
        width:70px;
        height:40px;
        float:left;
        color:#333333;
    }
    .sHistoryRight{
        width:480px;
        height:50px;
        float:left;
        overflow-x: auto;
        overflow-y: hidden;
        .sHistoryScroll{
            font-size:15px;
        }
        .textListHistory{
            display: inline-block;
            padding:0 10px;
            cursor:pointer;
            color:#888888;
        }
    }
}


.typeBox {
  width: 1200px;
  display: flex;
  margin: 0 auto;
  height: 210px;
  justify-content: space-between;
}

.typeBox img:hover {
  transform: translateY(-10px);
}

.hover {
  transform: translateY(-10px);
}

.searchInput .el-input__inner {
  height: 58px !important;
  border-radius: 0 !important;
  border: 2px solid #0f59a4 !important;
}

.searchInput {
  width: calc(100% - 450px) !important;
  // height:58px;
  background: #fff;
  margin-right: 10px;
}

.searchType {
  width: 140px;
  height: 58px;
  line-height: 58px;
  text-align: center;
  background: #0f59a4 !important;
  border: #0f59a4 !important;
  border-radius: 0 !important;
}

.searchType span {
  font-weight: 700;
  line-height: 18px;
}

.el-tree .el-input__inner {
  height: 58px !important;
  line-height: 58px !important;
}

.el-button {
  padding: 0;
}

// el-tree指示线样式
.tree_container {
  .el-tree > .el-tree-node:after {
    border-top: none;
  }

  .el-tree-node {
    position: relative;
    padding-left: 16px;
  }

  //节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉
  .el-tree-node__expand-icon.is-leaf {
    display: none;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node :last-child:before {
    height: 38px;
  }

  .el-tree > .el-tree-node:before {
    border-left: none;
  }

  .el-tree > .el-tree-node:after {
    border-top: none;
  }

  .el-tree-node:before {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  .el-tree-node:after {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  .el-tree-node:before {
    border-left: 1px dashed #e6e6e6;
    bottom: 0px;
    height: 100%;
    top: -22px;
    width: 1px;
  }

  .el-tree-node:after {
    border-top: 1px dashed #e6e6e6;
    height: 20px;
    top: 16px;
    width: 24px;
  }

  .el-tree-node__content {
    padding-left: 10px !important;
  }
}

.banner {
  width: 1200px;
  height: 120px;
  margin: 0 auto;
  // position: relative;

  // img{
  //   position: absolute;
  // }
  // img:last-child{
  //   position: absolute;
  //   bottom: 30px;
  //   left: 98px;
  // }
}

.el-table tr {
  background-color: #f5f5f5;
}

.el-drawer__header > :first-child {
  font-size: 22px;
  color: #333;
}

.el-table th.el-table__cell > .cell {
  color: #333;
  font-size: 16px;
  font-weight: 700;
}

.el-table td.el-table__cell {
  border-bottom: none !important;
}

.el-table th.el-table__cell.is-leaf {
  border-bottom: none !important;
}

.el-table::before {
  content: "" !important;
  background-color: #fff !important;
}
.riri {
  border-bottom: 12px solid #f8f8f8;
}
::v-deep .el-drawer__header {
  margin: 0;
  padding: 0;
}
.tanone{
  width: 100%;
  height: 70px;
  color: #124baa;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.taner{
width: 87%;
height: 45px;
background: #f5f5f5;
color:#124baa;
font-size:18px;
margin-left: 7%;
display: flex;
align-items: center;
}
.tansan{
width: 87%;
height: 45px;
font-size:18px;
margin-left: 7%;
display: flex;
align-items: center;
justify-content: space-between;
margin-top: 30px;
}
.tansi{
  width: 80px;
  height: 36px;
  background: #0f59a4;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color:#fff;
  cursor: pointer;
}
.tanzi{
  margin-left: 20px;
  width: 64%;
  text-overflow:ellipsis;
  overflow:hidden;
  white-space:nowrap
}
.actyifenlei{
  background: #0f59a4;
  color: #fff !important;
}
.actyifenleiwenzi{
  color:#fff !important;
}
// .fenone{
//   max-width: 500px;
//   display: flex;
//   flex-wrap: wrap;
//   height: auto;
//   border: 0;
// }
</style>
